import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { VersionService } from '../../_services/version.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  public version$: Observable<string>;
  private _clickCount = 0;

  constructor(private versionService: VersionService, private router: Router) {
    this.version$ = this.versionService.get();
  }

  countClick() {
    this._clickCount++;
    if (this._clickCount === 5) {
      this._clickCount = 0;
      this.router.navigate(['/reset-device']);
    }
  }
}
